import type { ReactNode } from "react";
import { forwardRef } from "react";
import type { LinkProps as ReactAriaLinkProps } from "react-aria-components";
import { Link as ReactAriaLink } from "react-aria-components";

import { cn, cv, type VariantProps } from "../utils";
import { ncButtonClasses, ncLinkClasses } from "./nc-button";

export const ncLinkVariants = cv(ncLinkClasses.base, {
  variants: {
    variant: {
      default: ncLinkClasses.variant.default,
      icon: [ncButtonClasses.base, ncButtonClasses.variant.icon],
      buttonPrimary: [ncButtonClasses.base, ncButtonClasses.variant.primary],
      button: [ncButtonClasses.base, ncButtonClasses.variant.default],
      buttonDanger: [ncButtonClasses.base, ncButtonClasses.variant.danger],
      buttonIcon: [ncButtonClasses.base, ncButtonClasses.variant.icon],
      buttonIconDanger: [ncButtonClasses.base, ncButtonClasses.variant.iconDanger],
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export interface CommonLinkProps extends VariantProps<typeof ncLinkVariants> {
  isDisabled?: boolean;
  children: ReactNode;
}

export interface NcLinkProps extends Omit<ReactAriaLinkProps, "children">, CommonLinkProps {}

export const NcLink = forwardRef<HTMLAnchorElement, NcLinkProps>(
  ({ variant = "default", isDisabled, children, className, ...props }, ref) => (
    <ReactAriaLink
      data-nc="NcLink"
      ref={ref}
      className={cn(ncLinkVariants({ variant }), className)}
      isDisabled={isDisabled}
      {...props}
    >
      {children}
    </ReactAriaLink>
  )
);
